import { useCallback, useState } from 'react';
import SiteLightbox from './SiteLightbox.jsx';
import { withBasePath } from '../utils/paths.js';

/**
 * Clickable photo grid + lightbox (events / VIP / cargo pattern from PHP).
 */
export default function PhotoGallery({
  photos,
  gridClass = 'gallery-grid',
  galleryId,
  emptyNote = 'Photos will appear here when available.',
  openLabel = (i, total) => `Open photo ${i + 1} of ${total}`,
  lightboxLabel = 'Photo viewer',
}) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const total = photos.length;

  const openAt = (i) => {
    setIndex(i);
    setOpen(true);
  };

  const close = useCallback(() => setOpen(false), []);
  const next = useCallback(() => {
    setIndex((i) => (i + 1) % total);
  }, [total]);
  const prev = useCallback(() => {
    setIndex((i) => (i - 1 + total) % total);
  }, [total]);

  if (!total) {
    return <p className="inner-note">{emptyNote}</p>;
  }

  return (
    <>
      <div className={gridClass} id={galleryId} role="list" data-lightbox-gallery="">
        {photos.map((photo, i) => (
          <button
            key={photo.src}
            type="button"
            className="gallery-grid__item gallery-grid__item--btn"
            role="listitem"
            aria-label={openLabel(i, total)}
            onClick={() => openAt(i)}
          >
            <img
              className="gallery-grid__img"
              src={withBasePath(photo.src)}
              alt={photo.alt || ''}
              width="800"
              height="600"
              loading="lazy"
              decoding="async"
            />
          </button>
        ))}
      </div>

      <SiteLightbox
        open={open}
        index={index}
        photos={photos}
        onClose={close}
        onPrev={prev}
        onNext={next}
        label={lightboxLabel}
      />
    </>
  );
}
